import styled from "styled-components";

const CircleStyled = styled.div`
  width: 970px;
  height: 970px;
  border-radius: 50%;
  background-color: #575fcc;
  position: absolute;
  transform: ${(props) =>
    `translate(${props.circlePosition.x}px, ${props.circlePosition.y}px)`};
  z-index: 1;
  transition: transform 0.3s ease-in-out;
`;

export default CircleStyled;
